export interface FacilityShiftsCalendarParams {
  startDate?: string;
  endDate?: string;
}

export interface FacilityShiftsCalendarDto {
  confirmedDates: string[];
  needsAttentionDates: string[];
}
